import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus, BoxIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string | number;
  subValue?: string;
  icon?: BoxIcon;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  color?: 'default' | 'blue' | 'green' | 'amber' | 'red';
  className?: string;
}
export function MetricCard({
  title,
  value,
  subValue,
  icon: Icon,
  trend,
  trendValue,
  color = 'default',
  className = ''
}: MetricCardProps) {
  const colorStyles = {
    default: 'bg-white border-slate-200',
    blue: 'bg-blue-50 border-blue-100',
    green: 'bg-green-50 border-green-100',
    amber: 'bg-amber-50 border-amber-100',
    red: 'bg-red-50 border-red-100'
  };
  const iconColors = {
    default: 'text-slate-500',
    blue: 'text-blue-600',
    green: 'text-green-600',
    amber: 'text-amber-600',
    red: 'text-red-600'
  };
  return <div className={`p-5 rounded-xl border shadow-sm transition-all hover:shadow-md ${colorStyles[color]} ${className}`} data-id="element-177">
      <div className="flex justify-between items-start mb-2" data-id="element-178">
        <h3 className="text-sm font-medium text-slate-500 truncate pr-2" data-id="element-179">
          {title}
        </h3>
        {Icon && <Icon className={`h-5 w-5 ${iconColors[color]}`} data-id="element-180" />}
      </div>

      <div className="flex items-baseline gap-2" data-id="element-181">
        <span className="text-2xl font-bold text-slate-900" data-id="element-182">{value}</span>
        {subValue && <span className="text-sm text-slate-500" data-id="element-183">{subValue}</span>}
      </div>

      {trend && <div className="mt-3 flex items-center text-xs font-medium" data-id="element-184">
          {trend === 'up' && <ArrowUpRight className="h-3.5 w-3.5 text-green-600 mr-1" data-id="element-185" />}
          {trend === 'down' && <ArrowDownRight className="h-3.5 w-3.5 text-red-600 mr-1" data-id="element-186" />}
          {trend === 'neutral' && <Minus className="h-3.5 w-3.5 text-slate-400 mr-1" data-id="element-187" />}

          <span className={trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : 'text-slate-500'} data-id="element-188">
            {trendValue}
          </span>
          <span className="text-slate-400 ml-1" data-id="element-189">vs last month</span>
        </div>}
    </div>;
}